import { Tag } from 'antd';
import { ReactNode } from 'react';

import { OfferLabel } from '../interfaces/offersInterface';

type OfferTags = {
  label?: OfferLabel;
  isFallbackOffer?: boolean;
};

export function renderOfferNameWithTags(name: ReactNode, offer: OfferTags) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <span>{name}</span>
      {offer.isFallbackOffer && (
        <Tag
          data-testid='default-tag'
          style={{ marginInlineStart: '10px', maxHeight: '22px' }}
          color='blue'
        >
          Base e Fallback
        </Tag>
      )}
      {offer.label === 'default' && !offer.isFallbackOffer && (
        <Tag
          data-testid='default-tag'
          style={{ marginInlineStart: '10px', maxHeight: '22px' }}
          color='blue'
        >
          Base
        </Tag>
      )}
      {offer.label === 'currentDefault' && (
        <Tag
          data-testid='current-default-tag'
          style={{ marginInlineStart: '10px', maxHeight: '22px' }}
          color='cyan'
        >
          Prioritária
        </Tag>
      )}
    </div>
  );
}
